module.exports = __webpack_public_path__ + "img/Wales.20d77d29.png";